export class ShiftClass {
    id: number;
    name: string;
    price: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}